export enum Environment {
  Local = "local",
  Development = "development",
  Production = "production",
}

export function getEnvironment(): Environment {
  const { origin, pathname } = window.location;
  const fullUrl = origin + pathname;

  if (origin.includes("localhost") || origin.includes("127.0.0.1")) {
    return Environment.Local;
  }

  if (fullUrl.startsWith("https://dev.reno-desk.com")) {
    return Environment.Development;
  }

  return Environment.Production;
}

export const getApiUrl = () => {
  const backendUrls: Record<Environment, string> = {
    [Environment.Local]: import.meta.env.VITE_API_URL_DEV,
    [Environment.Development]: import.meta.env.VITE_API_URL_DEV,
    [Environment.Production]: import.meta.env.VITE_API_URL_PROD,
  };

  const env = getEnvironment();
  const url = backendUrls[env];

  return url ?? import.meta.env.VITE_API_URL_PROD;
};

export function isProduction() {
  return getEnvironment() === Environment.Production;
}

export function isDevelopment() {
  return getEnvironment() === Environment.Development;
}

export function isLocal() {
  return getEnvironment() === Environment.Local;
}
